import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, Switch, BrowserRouter, withRouter } from "react-router-dom";
import { withCookies} from "react-cookie";

import { mainRoutes, getOfficeRoutes } from "./routes";
import Loading from "../Components/Loading";

import { fetchData } from "../action/identity";

const mapStateToProps = ({ identity }) => identity || {};

const mapDispatchToProps = dispatch => ({
  fetchIdentity: authKey => dispatch(fetchData(authKey))
});

class App extends Component {
  componentDidMount = () => {
    const { isFetching, isFetched, hasError, cookies } = this.props;
    const authKey = cookies.get(process.env.REACT_APP_IDENTITY_COOKIE);
    if (!(isFetched && isFetching && hasError) && authKey) {
      this.props.fetchIdentity(authKey);
    }
  };

  render() {
    const { id, isFetching, position } = this.props;
    let routes = [];
    if (!id) {
      if (isFetching) {
        return <Loading loading />;
      }
      routes = mainRoutes;
    } else {
      routes = getOfficeRoutes(position === 'admin');
    }

    return (
      <div>
        <BrowserRouter>
          <Switch>
            {routes.map(
              (
                { layout, layoutProps, component, componentProps, ...route },
                idx
              ) => {
                const componentRender = () =>
                  React.createElement(component, componentProps || {});
                const pageRender = () =>
                  React.createElement(
                    layout,
                    layoutProps || {},
                    componentRender()
                  );
                return (
                  <Route render={pageRender} {...route} key={`route${idx}`} />
                );
              }
            )}
          </Switch>
        </BrowserRouter>
      </div>
    );
  }
}

export default withRouter(
  withCookies(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(App)
  )
);



// WEBPACK FOOTER //
// ./src/containers/App.jsx